<headerCustom></headerCustom>

<!--Add User Modal Box-->
<div *ngIf="showHideModel" class="modal fade" id="formDailogContainer" tabindex="-1" role="dialog" aria-labelledby="formDailogContainer"
  aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <form [formGroup]="formObj">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Functional Competencies Form</h5>
          <button type="button" class="close" #closeModel data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <input *ngIf="formObj.value.skillId" type="hidden" formControlName="skillId">
        <div class="modal-body">
          <div class="form-group row">
            <label for="skillName" class="col-sm-4 col-form-label control-label">Competency name</label>
            <div class="col-sm-8">
              <input type="text" [ngClass]="{ 'is-invalid': submitted && f.skillName.errors }" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Competency name'"
                placeholder="Competency name" class="form-control" formControlName="skillName">
            </div>
          </div>

          <!-- <div class="form-group row">
            <label for="skillCode" class="col-sm-4 col-form-label control-label">Skill code</label>
            <div class="col-sm-8">
              <input type="text" [ngClass]="{ 'is-invalid': submitted && f.skillCode.errors }" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Skill code'"
                placeholder="Skill code" class="form-control" formControlName="skillCode">
            </div>
          </div> -->

          <div class="form-group row">
            <label for="targetScore" class="col-sm-4 col-form-label control-label">Target score</label>
            <div class="col-sm-8">
              <input type="number" min="1" max="5" [ngClass]="{ 'is-invalid': submitted && f.targetScore.errors }" onfocus="this.placeholder = ''"
                onblur="this.placeholder = 'Target Score'" placeholder="Target Score" class="form-control" formControlName="targetScore">
            </div>
          </div>

          <div class="form-group row" *ngIf="common.isSuperUser()">
            <label for="towerDropDown" class="col-sm-4 col-form-label control-label">Tower</label>
            <div class="col-sm-8">
              <select id="towerDropDown" class="form-control" formControlName="towerId" [(ngModel)]='towerSelect' (ngModelChange)="updatePositionList()">
                <option *ngFor="let tower of allTowers;" value="{{tower.towerId}}">{{ tower.towerName }}</option>
              </select>
            </div>
          </div>

          <div class="form-group row">
            <label for="positionId" class="col-sm-4 col-form-label control-label">Position</label>
            <div class="col-sm-8">
              <select id="positionDropDown" class="form-control" formControlName="positionId">
                <option *ngFor="let position of allPositions;" value="{{position.positionId}}">{{ position.positionName }}</option>
              </select>
            </div>
          </div>

          <div formArrayName="arrOfTraining" class="form-group row">
            <label for="arrOfTraining" class="col-sm-4 col-form-label">Trainings</label>
            <div  class="col-sm-8" *ngIf = "!formObj.value.skillId">
              <div *ngFor="let item of arr_of_training.controls; let i = index;"  [formGroupName]="i">
                <input type="text" [ngClass]="{ 'is-invalid': submitted && f.trainingPoint.errors }" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Training name'"
                  placeholder="Training name" class="form-control" formControlName="trainingPoint" style="margin-bottom: 15px;">
              </div>
            </div>
            <div class="col-sm-8" *ngIf = "formObj.value.skillId">
              <div *ngFor="let item of arr_of_training_update.controls; let i = index;" [formGroupName]="i">
                <input type="text" [ngClass]="{ 'is-invalid': submitted && f.trainingPoint.errors }" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Training name'"
                  placeholder="Training name" class="form-control" formControlName="trainingPoint" value="{{item.value.trainingPoint}}" style="margin-bottom: 15px;">
              </div>
            </div>
            <ng-container *ngIf = "!formObj.value.skillId">
              <!-- <div class="col-sm-8" *ngFor="let item of arr_of_training.controls; let i = index;"  [formGroupName]="i" >
                <input type="text" [ngClass]="{ 'is-invalid': submitted && f.trainingPoint.errors }" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Training name'"
                  placeholder="Training name" class="form-control" formControlName="trainingPoint">
              </div> -->
              <div class="col-sm-4">
                <button  type="button" class=" col-sm-2 btn btn-info btn-sm" (click)="addTraining()">+</button>&nbsp;
                <button  type="button" class=" col-sm-2 btn btn-danger btn-sm"(click)="deleteTraining(i)">-</button>
              </div> 
            </ng-container>
            <ng-container *ngIf = "formObj.value.skillId">             
              <!-- <div class="col-sm-8" *ngFor="let item of arr_of_training_update.controls; let i = index; trackBy:getIndex" [formGroupName]="i">
                <input type="text" [ngClass]="{ 'is-invalid': submitted && f.trainingPoint.errors }" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Training name'"
                  placeholder="Training name" class="form-control" formControlName="trainingPoint" value="{{item.value.trainingPoint}}">
              </div> -->
            <div class="col-sm-4">
              <button  type="button" class=" col-sm-2 btn btn-info btn-sm" (click)="addTrainingUpdate()">+</button>&nbsp;
              <button  type="button" class=" col-sm-2 btn btn-danger btn-sm"(click)="deleteTrainingUpdate(i)">-</button>
            </div> 
          </ng-container>           
          </div>

        </div>
        <div class="modal-footer">
          <button *ngIf="!formObj.value.skillId" class="btn hvr-bounce-to-top" (click)="onSubmit(formObj.value)" [disabled]="formObj.invalid">Add Competency</button>
          <button *ngIf="formObj.value.skillId" type="button" class="btn hvr-bounce-to-top" (click)="updateSkill(formObj.value)">Update Competency</button>
          <button type="button" class="btn hvr-bounce-to-top" data-dismiss="modal" aria-label="Close">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>

<app-admin-sidebar *ngIf="common.isSuperUser()"></app-admin-sidebar>
<sidebarWrapper *ngIf="!common.isSuperUser()"></sidebarWrapper>

<div class="main-content">
  <div class="adduserContainer">
    <div class="pageContentWrapper">
      <div class="pageHeading">
        <div class="row">
          <div class="col-8">
            <div class="headerName">
              <h3>Functional Competencies Information</h3>
              <app-breadcrumb></app-breadcrumb>
              <!-- <div class="labelLinks">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    
                    <li class="breadcrumb-item active" aria-current="page">Functional Competencies Information</li>
                  </ol>
                </nav>
              </div> -->
            </div>
          </div>
          <div class="col-4 addUserButton">
            <button type="button" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#formDailogContainer"
              (click)="initUserInfo()">Add Competency
            </button>
            <a class="btn hvr-bounce-to-top mr10" href="assets/behCompetancy.pdf" target="_blank">Definition</a>
            <!-- <button type="button" class="btn hvr-bounce-to-top mr10" (click)="initUserInfo()">Definition
            </button> -->
          </div>
        </div>
      </div>

      <div class="row mb-3">
          <ng-container *ngIf="common.isSuperUser()">
            <div class="scoreCompStyle col-md-2" id="adduserPopContainer1" *ngIf="allTowers && allTowers.length >0">
              <div class="cusPad">
                <label>Select Tower</label>
                <select class="form-control" [(ngModel)]="selectedTowerId" placeholder="Select Tower"
                  (ngModelChange)="getPositionList(selectedTowerId)">
                  <option value="0" >Select Tower</option>
                  <ng-container *ngFor="let tower of allTowers; let i = index;">
                    <option value="{{tower.towerId}}">{{tower.towerName}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </ng-container>
            <div class="scoreCompStyle col-md-3" id="adduserPopContainer2" *ngIf="allPositions && allPositions.length >0">
              <div class="cusPad">
                <label>Select Position</label>
                <select class="form-control" [(ngModel)]="selectedPositionId" placeholder="Select Position" (ngModelChange)="getAllSkills()">
                  <option value="0" selected>Select Position</option>
                  <ng-container *ngFor="let position of allPositions; let i = index;">
                    <option value="{{position.positionId}}">{{position.positionName}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
      </div>

      <div class="row mb-1">
        <div class="col-md-12">
          <div class="levelWrapper">
            <div class="levelBoard level-1">
              <h5>
                Level 1
                <span class="icon-level tooltipt">
                  <i class="fa fa-info" title=""></i>
                  <span class="tooltiptext">Clear need to improve in the competency (deficiency/improvement required)</span>
                </span>
              </h5>
              <span>Needs handholding</span>
            </div>
            <div class="levelBoard level-2">
              <h5>
                Level 2
                <span class="icon-level tooltipt">
                  <i class="fa fa-info" title=""></i>
                  <span class="tooltiptext">Not always up to standard, with inconsistent demonstration of the competency (below average)</span>
                </span>
              </h5>
              <span>Needs review</span>
            </div>
            <div class="levelBoard level-3">
              <h5>
                Level 3
                <span class="icon-level tooltipt">
                  <i class="fa fa-info" title=""></i>
                  <span class="tooltiptext">Mostly demonstrates the competency as expected (at standard/average)</span>
                </span>
              </h5>
              <span>Needs audit</span>
            </div>
            <div class="levelBoard level-4">
              <h5>
                Level 4
                <span class="icon-level tooltipt">
                  <i class="fa fa-info" title=""></i>
                  <span class="tooltiptext">Notable strength in the competency (better than most)</span>
                </span>
              </h5>
              <span>Is independent</span>
            </div>
            <div class="levelBoard level-5">
              <h5>
                Level 5
                <span class="icon-level tooltipt">
                  <i class="fa fa-info" title=""></i>
                  <span class="tooltiptext">Strong role model (one of the best)</span>
                </span>
              </h5>
              <span>Can train others</span>
            </div>

          </div>
        </div>
      </div>

      <div class="addUserButtonTableData" *ngIf="formInfoList.length >0">
        <div class="addUserFormContainer addUserFormLayout customizeRtsScrollBar">
          <table datatable="ng" class=" table table-striped lh-23 rsTable userRcCustomTable customizeRtsScrollBar">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Competency name</th>
                <!-- <th>Skill code</th> -->
                <th>Target score</th>
                <!-- <th *ngIf="common.isSuperUser()">IBU</th> -->
                <th *ngIf="common.isSuperUser()">Tower</th>
                <th>Position</th>
                <th data-orderable="false">Action</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr *ngFor="let formInfo of formInfoList; let i = index;">
                <td>
                  <div>{{formInfoList.indexOf(formInfo) + 1}}</div>
                </td>
                <td>
                  <div>{{formInfo.skillName}}</div>
                </td>
                <!-- <td>
                  <div>{{formInfo.skillCode}}</div>
                </td> -->

                <td>
                  <div>{{formInfo.targetScore}}</div>
                </td>

                <!-- <td *ngIf="common.isSuperUser()">
                  <div>{{formInfo.ibuName}}</div>
                </td> -->

                <td *ngIf="common.isSuperUser()">
                  <div>{{formInfo.towerName}}</div>
                </td>

                <td>
                  <div>{{formInfo.positionName}}</div>
                </td>

                <td class="addUserButtons">
                  <button class="btn form-group hvr-bounce-to-top" data-backdrop="static" data-keyboard="false" title="Edit" type="button"
                    data-toggle="modal" data-target="#formDailogContainer" (click)="setUpdateUserInfo(formInfo, i)">
                    <img src="assets/edit.svg" />
                  </button>
                  <!-- <button class="btn form-group hvr-bounce-to-top" title="Delete" type="button"
                        (click)="onDeleteSubmit(formInfo)">
                        <img src="assets/delete.svg" />
                      </button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>